var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"confirm-modal__buttons"},[_c('button',{staticClass:"confirm-modal__button",attrs:{"type":"button"},on:{"click":_vm.onCancel}},[_vm._v(_vm._s(_vm.cancelTitle))]),_c('button',{staticClass:"confirm-modal__button negative",attrs:{"type":"button"},on:{"click":_vm.onConfirm}},[_vm._v(_vm._s(_vm.confirmTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }